import styled from "styled-components";

export const SmallButton = styled.button`
  display: inline-block;
  margin: auto;
  background: transparent;
  font: inherit;
  font-size: 0.8em;
  border: 0;
  outline: 0;
  padding: 0;
  transition: all 100ms ease-in;
  cursor: pointer;
  background: #cccccc;
  color: #111111;
  box-shadow: 0 0 10px 2px rgb(0 0 0 / 10%);
  border-radius: 2px;
  padding: 6px 10px;
  margin-bottom: 1em;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 0.9;
  }

  &:disabled {
    background: #dddddd;
    cursor: initial;
  }

  &.stick-right {
    float: right;
  }
`;
